/**
 * Shared card styles — single source of truth for cyberpunk card appearance.
 *
 * The actual background color is controlled by the CSS variable --bg-card
 * in global.css (enforced via !important on .MuiPaper-root). These sx props
 * provide border, overflow, and accent line styling.
 *
 * To change card color globally: edit --bg-card in global.css
 * To change border-radius globally: edit border-radius in global.css .MuiPaper-root
 */
import { SxProps, Theme } from '@mui/material';

export const cyberpunkCardSx: SxProps<Theme> = {
  // Background intentionally omitted — controlled by global.css --bg-card
  border: '1px solid rgba(0,224,255,0.15)',
  borderRadius: 2,
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0, left: 0, right: 0,
    height: '2px',
    background: 'linear-gradient(90deg, transparent, #00E0FF, transparent)',
  },
};

/**
 * Card without the top accent line — for secondary/list cards
 * where the gradient bar would create visual noise.
 */
export const cyberpunkCardCleanSx: SxProps<Theme> = {
  border: '1px solid rgba(0,224,255,0.1)',
  borderRadius: 2,
  position: 'relative',
  overflow: 'hidden',
};
